import { render, staticRenderFns } from "./propertyActionForm.vue?vue&type=template&id=a214b918&%23default=true&"
import script from "./propertyActionForm.vue?vue&type=script&lang=js&"
export * from "./propertyActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports